import { ReactElement } from 'react'
import styled from 'styled-components'

import { IRoutingProjectDataset } from 'features/RoutingProjects/types'
import { StopIndex } from 'components/Map/StopIndex'
import { LocationDetails } from 'features/RoutingProjects/components/LocationDetails'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const DatasetName = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #28265d;
`

const Split = styled.div`
  border-bottom: 1px solid #e9e9e9;
`

const LocationsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const LocationItem = styled.li`
  display: flex;
  gap: 8px;
  align-items: center;
`

interface IDatasetLocationsListProps {
  dataset: IRoutingProjectDataset
}

export const DatasetLocationsList = ({ dataset }: IDatasetLocationsListProps): ReactElement => {
  return (
    <Container>
      <DatasetName>{dataset.name}</DatasetName>
      <Split />
      {dataset.locations?.map((location, locationIndex) => {
        return (
          <LocationsList key={location.id}>
            <LocationItem>
              <StopIndex color="#28265D" bgColor="#F8F8F8">
                {locationIndex + 1}
              </StopIndex>
              <LocationDetails location={location} />
            </LocationItem>
          </LocationsList>
        )
      })}
    </Container>
  )
}
